const reasons = [
  { icon: "ri-focus-3-line", title: "Design-Driven Approach", desc: "Every project balances beauty and function — we never sacrifice one for the other." },
  { icon: "ri-ruler-2-line", title: "Technical Precision", desc: "Meticulous attention to detail ensures every plan is accurate, complete, and build-ready." },
  { icon: "ri-lightbulb-line", title: "Ideas Into Reality", desc: "We translate your vision into buildable, code-compliant architectural plans." },
  { icon: "ri-user-heart-line", title: "Client-First Commitment", desc: "Your goals drive every decision. We listen, refine, and deliver what you actually need." },
  { icon: "ri-award-line", title: "40+ Years of Expertise", desc: "Decades of experience across architecture, real estate, and construction — all under one roof." },
  { icon: "ri-home-2-line", title: "Residential & Commercial", desc: "Proven capability across project types — from custom homes to large commercial developments." },
];

export default function WhyChooseUs() {
  return (
    <section className="py-28 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left image */}
          <div className="relative">
            <img
              src="https://www.archiconservices.com/img/feature-pic.jpg"
              alt="Archicon Services architectural work"
              className="w-full h-[500px] object-cover object-top rounded-sm"
            />
            <div className="absolute bottom-6 left-6 bg-white p-5 rounded-sm max-w-xs">
              <p className="text-stone-900 font-semibold text-2xl" style={{ fontFamily: "'Cormorant Garamond', serif" }}>40+</p>
              <p className="text-stone-500 text-xs tracking-widest uppercase mt-1" style={{ fontFamily: "'Inter', sans-serif" }}>Years of Building Industry Experience</p>
            </div>
          </div>

          {/* Right content */}
          <div>
            <p className="text-xs tracking-widest uppercase text-amber-600 mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>Why Archicon</p>
            <h2 className="text-4xl md:text-5xl font-light text-stone-900 leading-tight mb-10" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Your Partner in<br /><em className="not-italic font-semibold">Precision Design</em>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              {reasons.map((r, i) => (
                <div key={i} className="flex flex-col gap-2">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className={`${r.icon} text-xl text-amber-600`}></i>
                  </div>
                  <h4 className="text-stone-900 font-medium text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>{r.title}</h4>
                  <p className="text-stone-500 text-xs leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>{r.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
